import { useLanguageState } from "../globalStates/LanguageState"

interface LocalizedStaticTexts {
    de: StaticTexts
    en: StaticTexts
    [key: string]: StaticTexts
}

export interface StaticTexts {
    cancel: string
    ok: string
    confirm: string
    download: string
    save: string
    delete: string
    active: string
    status: string
    demoProductStatus: {
        available: string
        used: string
        outOfOrder: string
    }
    socialMedia: {
        facebook: string
        instagram: string
        linkedIn: string
        xing: string
        x: string
        youTube: string
        pinterest: string
        tiktok: string
    }
}

const staticTexts: LocalizedStaticTexts = {
    en: {
        cancel: "Cancel",
        confirm: "Confirm",
        ok: "OK",
        download: "Download",
        save: "Save",
        delete: "Delete",
        active: "Active",
        status: "Status",
        demoProductStatus: {
            available: "Available",
            used: "Used",
            outOfOrder: "Out of order"
        },
        socialMedia: {
            facebook: "Facebook",
            instagram: "Instagram",
            linkedIn: "LinkedIn",
            xing: "Xing",
            x: "X",
            youTube: "YouTube",
            pinterest: "Pinterest",
            tiktok: "TikTok"
        }
    },
    de: {
        cancel: "Abbrechen",
        confirm: "Confirm",
        ok: "OK",
        download: "Herunterladen",
        save: "Speichern",
        delete: "Löschen",
        active: "Aktiv",
        status: "Status",
        demoProductStatus: {
            available: "Verfügbar",
            used: "Aktuell verwendet",
            outOfOrder: "Außer Betrieb"
        },
        socialMedia: {
            facebook: "Facebook",
            instagram: "Instagram",
            linkedIn: "LinkedIn",
            xing: "Xing",
            x: "X",
            youTube: "YouTube",
            pinterest: "Pinterest",
            tiktok: "TikTok"
        }
    }
}

function useStaticTexts(): StaticTexts {
    const lang = useLanguageState().getLanguage()

    return staticTexts[lang]
}

export default useStaticTexts
